import { render, staticRenderFns } from "./BuyCard.vue?vue&type=template&id=4ff6ee7e&scoped=true&"
import script from "./BuyCard.vue?vue&type=script&lang=js&"
export * from "./BuyCard.vue?vue&type=script&lang=js&"
import style0 from "./BuyCard.vue?vue&type=style&index=0&id=4ff6ee7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff6ee7e",
  null
  
)

export default component.exports